import React from "react";
import "./analytics-tabs.scss";

export default function AnalyticsTabs({ tabs, active, onChange, id }) {
  const move = (event, index) => {
    let next = index;
    if (event.key === "ArrowRight") next = (index + 1) % tabs.length;
    else if (event.key === "ArrowLeft") next = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === "Home") next = 0;
    else if (event.key === "End") next = tabs.length - 1;
    else return;
    event.preventDefault();
    onChange(tabs[next].key);
    document.getElementById(`${id}-tab-${tabs[next].key}`)?.focus();
  };

  return <div className="analytics-tabs" role="tablist" aria-label="Analytics sections">
    {tabs.map((tab, index) => <button
      key={tab.key}
      type="button"
      id={`${id}-tab-${tab.key}`}
      role="tab"
      aria-selected={active === tab.key}
      aria-controls={active === tab.key ? `${id}-panel-${tab.key}` : undefined}
      tabIndex={active === tab.key ? 0 : -1}
      onClick={() => onChange(tab.key)}
      onKeyDown={event => move(event, index)}
    ><span className="analytics-tabs__title"><strong>{tab.label}</strong>{tab.badge && <em className={tab.badge === "No AI" ? "analytics-tabs__badge analytics-tabs__badge--plain" : "analytics-tabs__badge"}>{tab.badge}</em>}</span><span>{tab.description}</span></button>)}
  </div>;
}
